import React from "react";
import { Box, Button } from "@mui/material";
import { tokens, withAlpha } from "../../../Common/designTokens";
const RfqActionButtons = ({ 
  venue, 
  isLoading,
  animationState,
  onAction,
  isButtonEnabled,
  isTrumidRfq
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        justifyContent: "center",
        opacity: animationState === "entered" ? 1 : 0,
        transition: "opacity 0.3s ease",
        transitionDelay: "0.2s",
      }}
    >
      <Button
        variant="none"
        size="small"
        disabled={!isButtonEnabled(venue.status, "accept") || isLoading}
        onClick={() => onAction("accept", venue)}
        sx={{
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: 700,
          backgroundColor: withAlpha(tokens.colors.buyBgColor, 0.133), // "22" hex ≈ 0.133 alpha
          color: tokens.colors.buyFontColor,
          padding: "8px 16px",
          border: `0.5px solid ${withAlpha(tokens.colors.buyFontColor, 0.2)}`, // "33" ≈ 0.2
          "&:hover": {
            backgroundColor: withAlpha(tokens.colors.buyBgColor, 0.2),
          },
          "&.Mui-disabled": {
            backgroundColor: tokens.colors.disabledBackground,
            color: tokens.colors.disabledFontColour,
            border: "none",
          },
        }}
      >
        Accept
      </Button>
      <Button
        variant="none"
        size="small"
        disabled={!isButtonEnabled(venue.status, "reject") || isLoading}
        onClick={() => onAction("reject", venue)}
        sx={{
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: 700,
          backgroundColor: withAlpha(tokens.colors.sellBgColor, 0.133),
          color: tokens.colors.sellFontColor,
          padding: "8px 16px",
          border: `0.5px solid ${withAlpha(tokens.colors.sellFontColor, 0.2)}`,
          "&:hover": {
            backgroundColor: withAlpha(tokens.colors.sellBgColor, 0.2),
          },
          "&.Mui-disabled": {
            backgroundColor: tokens.colors.disabledBackground,
            color: tokens.colors.disabledFontColour,
            border: "none",
          },
        }}
      >
        Reject
      </Button>
      <Button
        variant="none"
        size="small"
        disabled={!isButtonEnabled(venue.status, "counter") || isLoading}
        onClick={() => onAction("counter", venue)}
         sx={{
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: 700,
          backgroundColor: withAlpha(tokens.palette.primary, 0.067), // "11" ≈ 0.067
          color: tokens.palette.primary,
          padding: "8px 16px",
          border: `0.5px solid ${withAlpha(tokens.palette.primary, 0.2)}`, // "33" ≈ 0.2
          "&:hover": {
            backgroundColor: withAlpha(tokens.palette.primary, 0.133), // "22" ≈ 0.133
          },
          "&.Mui-disabled": {
            backgroundColor: tokens.colors.disabledBackground,
            color: tokens.colors.disabledFontColour,
            border: "none",
          },
          "&:active": {
            backgroundColor: `${tokens.palette.primary}33`,
          },
        }}
      >
        Counter
      </Button>
      {isTrumidRfq && (
        <Button
          variant="none"
          size="small"
          disabled={!isButtonEnabled(venue.status, "counter_cancel") || isLoading} // changed
          onClick={() => onAction("counter_cancel", venue)}
          sx={{
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: 700,
          backgroundColor: withAlpha(tokens.colors.amberColor, 0.15),
          color: tokens.colors.amberColor,
          padding: "8px 16px",
          border: `0.5px solid ${withAlpha(tokens.colors.amberColor, 0.15)}`,
          "&:hover": {
            backgroundColor: withAlpha(tokens.colors.amberColor, 0.25),
          },
          "&.Mui-disabled": {
            backgroundColor: tokens.colors.disabledBackground,
            color: tokens.colors.disabledFontColour,
            border: "none",
          },
        }}
        >
          Cancel Counter
        </Button>
      )}
    </Box>
  );
};

export default RfqActionButtons;